import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SelectedUserService, UserAppsService } from 'app/services';
import { User, UserApp } from 'app/models';
import { UserDialogComponent } from '../user-dialog/user-dialog.component';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericRoles } from 'app/helpers/constants';

@Component({
  standalone: false,
  selector: 'app-user-application-access',
  templateUrl: './user-application-access.component.html',
  styleUrls: ['./user-application-access.component.scss']
})
export class UserApplicationAccessComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  user: User;
  @Input()
  saveChanges: Subject<boolean>;
  @Input()
  clientId: any;
  @Output()
  isChanged = new EventEmitter<boolean>(false);
  @Output() isValid = new EventEmitter<boolean>(true); 
  initialApps: UserApp[] = [];
  userAppsError: string;
  apps: UserApp[];
  isUserProfileCompleted=false;
  public loading: boolean;
  message = 'No_Applications_Found';
  private onDestroy$ = new Subject<void>();

  constructor(
    public _userAppsService: UserAppsService,
    public dialogRef: MatDialogRef<UserDialogComponent>,
    public selectedUserService: SelectedUserService
  ) {} 

  ngOnChanges() {
    if (this.user) {
      this._userAppsService.getApps(this.user.id);
      this.subscribeToUsersAccess();
    }
  }

  ngOnInit() {
    this.getUserDetails();
    this._userAppsService.clearSubscription();
    this.saveChanges.subscribe(v => {
      this.updateRecord();
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  updateRecord(isReset?: boolean) {
    this._userAppsService.saveApps(
      this.user.id,
      this.apps,
      isReset,
      this.dialogRef,
      this.user.name,
      this.clientId
    );
  }

  reset(selectedApp, event) {
    selectedApp.toggleState = event.checked;
    if (!event.checked) {
      selectedApp.roles.forEach(role => {
        role.hasAccess = false;
      });
    } else {
      selectedApp.roles.forEach(role => {
        if (role.name.toLowerCase() === GenericRoles.userRole.toLowerCase()) {
          role.hasAccess = true;
        }
      });
    }
  }
  getUserDetails(){
    this.selectedUserService.selectedUser$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((user) => {
        if (user) {
          this.isUserProfileCompleted=user.isProfileCompleted || this.isInternalUser(user);
        }
      });
  }
  

  setToggleState() {
    this.apps.forEach(app => {
      const role = app.roles.find(r => r.name.toLowerCase() === GenericRoles.userRole.toLowerCase());
      if (role) {
        app.hasUserRole = true;
      } else {
        app.hasUserRole = false;
      }
      app.toggleState = app.roles.filter(ro => ro.hasAccess).length > 0;
    });
  }

  subscribeToUsersAccess(): void {
    this.loading = true;
    this._userAppsService.userApps$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((userApps: UserApp[]) => {
        if (userApps) {
          this.apps = userApps;
          this.loading = false;
          this.setToggleState();
          this.initialApps = JSON.parse(JSON.stringify(this.apps));
        } else {
          this.loading = true;
        }
      });
    this._userAppsService.error$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(error => {
        if (error) {
          this.userAppsError = error;
          this.loading = false;
          this._userAppsService.loadApps(this.user.id);
        }
      });
  }

  updatePermission(){
    this.isChanged.emit(JSON.stringify(this.apps) !== JSON.stringify(this.initialApps));
    this.isValid.emit(this.allToggledAppsHaveRoles());
  }

  private allToggledAppsHaveRoles(): boolean {
    if (!this.apps || this.apps.length === 0) {
      return true; 
    }
    const toggled = this.apps.filter(app => app.toggleState);
    if (toggled.length === 0) {
      return true;
    }
    return toggled.every(app => Array.isArray(app.roles) && app.roles.some(r => r.hasAccess));
  }


  isInternalUser(user: any){
    return user?.email.toLowerCase().includes('@allegion.com');
  }
}
